import { DateTime } from 'luxon'
import { GT_Assembly_Date, GT_Date } from '../../types/dates'
import { GT_Project, Project_Assembly_Meta } from '../../types/projects'
import { Grid_List } from '@app/post-lists/grid-list'
import ChangeEvent = JQuery.ChangeEvent
import ClickEvent = JQuery.ClickEvent
import SubmitEvent = JQuery.SubmitEvent

import { bus } from '@app/core/bus'
import { Toast } from '@app/utils/toast'

export class Assembly_Controller {
    public static sort_assembly_dates( a: string, b: string ): 1|0|-1 {
        const keyA = DateTime.fromSQL( a )
        const keyB = DateTime.fromSQL( b )

        // a vor b
        if ( keyA < keyB ) {
            return -1
        }

        // a nach b
        if ( keyA > keyB ) {
            return 1
        }

        return 0
    }
}

export class Create_Assembly_Presenter {
    constructor() {}

    ready() {
        this.init_calendars()
    }

    init_calendars() {
        const today = new Date();

        jQuery( '#project-assembly-date-week' ).closest( '.checkbox' ).checkbox(
            {
                onChecked: () => {
                    console.debug( 'KW checked' )
                    jQuery( '[data-assembly-date-type="week"]' ).show()
                    jQuery( '[data-assembly-date-type="day"]' ).hide()
                },
            }
        )

        jQuery( '#project-assembly-date-day' ).closest( '.checkbox' ).checkbox(
            {
                onChecked: () => {
                    console.debug( 'Day checked' )
                    jQuery( '[data-assembly-date-type="day"]' ).show()
                    jQuery( '[data-assembly-date-type="week"]' ).hide()
                },
            }
        )

        jQuery( '#date-assembly-week' )
            .calendar(
                {
                    type: 'date',
                    selectAdjacentDays: true,
                    firstDayOfWeek: 1,
                    disabledDaysOfWeek: [ 0, 6 ],
                    showWeekNumbers: true,
                    monthFirst: false,
                    minDate: today,
                    formatter: {

                        // @ts-expect-error -> falsches Overload
                        date: function( date: Date ): string {
                            if ( ! date ) {
                                return '';
                            }

                            const date_obj = DateTime.fromJSDate( date )
                            return date_obj.toFormat( 'WW/kkkk' )
                        },
                    },
                    text: app.calendar_text,
                    popupOptions: {
                        position: 'top left',
                    },
                    onChange: function( date: Date ) {
                        console.debug( 'date-assembly-week onchange', date )
                        jQuery( '#date-assembly-date' ).calendar( 'set date', date, true, false )
                    }
                }
            );

        jQuery( '#date-assembly-date' )
            .calendar(
                {
                    type: 'date',
                    selectAdjacentDays: true,
                    firstDayOfWeek: 1,
                    disabledDaysOfWeek: [ 0, 6 ],
                    showWeekNumbers: true,
                    monthFirst: false,
                    minDate: today,
                    formatter: {
                        date: 'DD.MM.YYYY',
                    },
                    text: app.calendar_text,
                    popupOptions: {
                        position: 'top left',
                    },
                    onChange: function( date: Date ) {
                        console.debug( 'date-assembly-date onchange', date )
                        jQuery( '#date-assembly-week' ).calendar( 'set date', date, true, false )
                    }
                }
            );
    }
}

export abstract class Manage_Assembly_Presenter {
    service: Manage_Assembly_Service
    modal: Manage_Assembly_Modal

    protected constructor() {
        this.modal = new Manage_Assembly_Modal()
        this.service = new Manage_Assembly_Service()
    }

    ready(): void {
        this.init_actions()
        this.init_calendars()
        this.init_forms()
        this.init_bus_events()
    }

    init_actions(): void {
        jQuery( '[data-action="delete-project-assembly"]' ).on( 'click', () => this.modal.init_delete_assembly_confirmation() )
        jQuery( '[data-action="delete-additional-assembly"]' ).on( 'click', () => this.modal.init_delete_additional_assembly_confirmation() )
    }

    init_calendars(): void {
        const today = new Date()

        jQuery( '#project-assembly-date-week-edit' ).closest( '.checkbox' ).checkbox(
            {
                onChecked: () => {
                    console.debug( 'KW checked' )
                    jQuery( '[data-assembly-date-type="week"]' ).show()
                    jQuery( '[data-assembly-date-type="day"]' ).hide()
                },
            }
        )

        jQuery( '#project-assembly-date-day-edit' ).closest( '.checkbox' ).checkbox(
            {
                onChecked: () => {
                    console.debug( 'Day checked' )
                    jQuery( '[data-assembly-date-type="day"]' ).show()
                    jQuery( '[data-assembly-date-type="week"]' ).hide()
                },
            }
        )

        jQuery( '#date-assembly-week-edit' )
            .calendar(
                {
                    type: 'date',
                    selectAdjacentDays: true,
                    firstDayOfWeek: 1,
                    disabledDaysOfWeek: [ 0, 6 ],
                    showWeekNumbers: true,
                    monthFirst: false,
                    formatter: {

                        // @ts-expect-error -> falsches Overload
                        date: function( date: Date ): string {
                            if ( ! date ) {
                                return '';
                            }

                            const date_obj = DateTime.fromJSDate( date )
                            return date_obj.toFormat( 'WW/kkkk' )
                        }
                    },
                    text: app.calendar_text,
                    popupOptions: {
                        position: 'top left',
                    },
                    onChange: function( date: Date ) {
                        console.debug( 'date-assembly-week-edit onchange', date )
                        jQuery( '#date-assembly-date-edit' ).calendar( 'set date', date, true, false )
                    }
                }
            )

        jQuery( '#date-assembly-date-edit' )
            .calendar(
                {
                    type: 'date',
                    selectAdjacentDays: true,
                    firstDayOfWeek: 1,
                    disabledDaysOfWeek: [ 0, 6 ],
                    showWeekNumbers: true,
                    monthFirst: false,
                    formatter: {
                        date: 'DD.MM.YYYY',
                    },
                    text: app.calendar_text,
                    popupOptions: {
                        position: 'top left',
                    },
                    onChange: function( date: Date ) {
                        console.debug( 'date-assembly-date-edit onchange', date )
                        jQuery( '#date-assembly-week-edit' ).calendar( 'set date', date, true, false )
                    }
                }
            )

        jQuery( '#date-additional-assembly-add' )
            .calendar(
                {
                    type: 'date',
                    selectAdjacentDays: true,
                    firstDayOfWeek: 1,
                    disabledDaysOfWeek: [ 0, 6 ],
                    showWeekNumbers: true,
                    monthFirst: false,
                    minDate: today,
                    formatter: {
                        date: 'DD.MM.YYYY',
                    },
                    text: app.calendar_text,
                    popupOptions: {
                        position: 'top left',
                    },
                }
            )

        jQuery( '#date-additional-assembly-update' )
            .calendar(
                {
                    type: 'date',
                    selectAdjacentDays: true,
                    firstDayOfWeek: 1,
                    disabledDaysOfWeek: [ 0, 6 ],
                    showWeekNumbers: true,
                    monthFirst: false,
                    formatter: {
                        date: 'DD.MM.YYYY',
                    },
                    text: app.calendar_text,
                    popupOptions: {
                        position: 'top left',
                    },
                }
            )
    }

    init_forms(): void {
        jQuery( '#form-edit-project-assembly' ).form(
            {
                errorFocus: false,
                revalidate: true,

                // @ts-expect-error Overload
                onSuccess: ( e: SubmitEvent ) => this.on_update_assembly_form_success( e ),
                onFailure: app.show_toast_invalid_form, // wichtig: return false nötig, sonst Submit Event.
                fields: {
                    'project-assembly-week-edit': {
                        rules: [
                            {
                                type: 'notEmpty',
                                prompt: 'Bitte eine Woche angeben. Falls du das Datum löschen möchtest, wähle die Aktion "löschen".'
                            }
                        ]
                    },
                    'project-assembly-date-edit': {
                        rules: [
                            {
                                type: 'notEmpty',
                                prompt: 'Bitte ein Datum angeben. Falls du das Datum löschen möchtest, wähle die Aktion "löschen".'
                            }
                        ]
                    }
                }
            }
        )

        jQuery( '#form-add-project-additional-assembly' ).form(
            {
                errorFocus: false,
                revalidate: true,

                // @ts-expect-error Overload
                onSuccess: ( e: SubmitEvent ) => this.on_add_additional_assembly_form_success( e ),
                onFailure: app.show_toast_invalid_form, // wichtig: return false nötig, sonst Submit Event.
                fields: {
                    'project-additional-assembly-add': {
                        rules: [
                            {
                                type: 'notEmpty',
                                prompt: 'Bitte ein Datum angeben.'
                            }
                        ]
                    }
                }
            }
        )

        jQuery( '#form-update-project-additional-assembly' ).form(
            {
                errorFocus: false,
                revalidate: true,

                // @ts-expect-error Overload
                onSuccess: ( e: SubmitEvent ) => this.on_update_additional_assembly_form_success( e ),
                onFailure: app.show_toast_invalid_form, // wichtig: return false nötig, sonst Submit Event.
                fields: {
                    'project-additional-assembly-update': {
                        rules: [
                            {
                                type: 'notEmpty',
                                prompt: 'Bitte ein Datum angeben. Falls du das Datum löschen möchtest, wähle die Aktion "löschen".'
                            }
                        ]
                    },
                },
            }
        )
    }

    init_bus_events(): void {
        bus.on( 'update-assembly:ajax:done', ( project: GT_Project, dates: GT_Date[] ) => this.on_update_assembly_ajax_success( project, dates ) )
        bus.on( 'delete-assembly:confirmation:approved', ( post_id: number ) => this.on_delete_assembly_confirmation_approve( post_id ) )
        bus.on( 'delete-assembly:ajax:done', ( project: GT_Project, dates: GT_Date[] ) => this.on_update_assembly_ajax_success( project, dates ) )

        bus.on( 'add-additional-assembly:ajax:done', ( dates: GT_Date[] ) => this.on_update_additional_assembly_ajax_success( dates ) )
        bus.on( 'update-additional-assembly:ajax:done', ( dates: GT_Date[] ) => this.on_update_additional_assembly_ajax_success( dates ) )
        bus.on( 'delete-additional-assembly:confirmation:approved', ( post_id: number ) => this.on_delete_additional_assembly_confirmation_approve( post_id ) )
        bus.on( 'delete-additional-assembly:ajax:done', ( dates: GT_Date[] ) => this.on_update_additional_assembly_ajax_success( dates ) )
    }

    abstract on_update_assembly_form_success( e: SubmitEvent ): void
    abstract on_update_assembly_ajax_success( project: GT_Project, dates: GT_Date[] ): void

    on_delete_assembly_confirmation_approve( post_id: number ): void {
        console.log( 'delete assembly', post_id )
        this.service.ajax_delete_assembly( post_id )
    }

    abstract on_add_additional_assembly_form_success( e: SubmitEvent ): void
    abstract on_update_additional_assembly_form_success( e: SubmitEvent ): void
    abstract on_update_additional_assembly_ajax_success( dates: GT_Date[] ): void

    on_delete_additional_assembly_confirmation_approve( post_id: number ): void {
        console.log( 'delete additional assembly', post_id )
        this.service.ajax_delete_additional_assembly( post_id )
    }
}

export class Project_Manage_Assembly_Presenter extends Manage_Assembly_Presenter {
    constructor() {
        super()
    }

    init_modal_update_assembly() {
        const assembly: Project_Assembly_Meta = project.get_meta_value( 'project-assembly' )
        this.modal.init_modal_update_assembly( project, assembly, project.dates )
    }

    /**
     * Event Handlers - Assembly
     */

    on_update_assembly_form_success( e: SubmitEvent ) {
        console.log( 'update assembly', e.currentTarget )

        // enable AJAX
        e.preventDefault()

        const form = jQuery( e.currentTarget )
        const form_data: string = form.serialize()

        this.service.ajax_update_assembly( project.post_id, form_data )
    }


    on_update_assembly_ajax_success( project_data: GT_Project, dates: GT_Date[] ): void {

        // @ts-expect-error in meta.js
        update_meta_list_item( 'project-assembly', project_data.assembly )

        // @ts-expect-error in meta.js
        update_meta_list_item( 'project-measurement', project_data.measurement )

        // @ts-expect-error in meta.js
        update_meta_list_item( 'project-construction-plans', project_data.construction_plans )

        // @ts-expect-error in meta.js
        update_meta_list_item( 'project-deadlines', project_data.deadlines )
        project.render_project_schedule()

        project.set_dates( dates )
        project.render_dates()
    }

    /**
     * Event Handlers - Additional Assembly
     */

    on_add_additional_assembly_form_success( e: SubmitEvent ) {
        console.log( 'add additional assembly', e.currentTarget )

        // enable AJAX.
        e.preventDefault()

        const form = jQuery( e.currentTarget )
        const form_data: string = form.serialize()

        this.service.ajax_add_additional_assembly( project.post_id, form_data )
    }

    on_update_additional_assembly_ajax_success( dates: GT_Date[] ): void {
        project.set_dates( dates )
        project.render_dates()
    }

    on_update_additional_assembly_form_success( e: SubmitEvent ) {
        console.log( 'update additional assembly', e.currentTarget )

        // enable AJAX.
        e.preventDefault()

        const form = jQuery( e.currentTarget )
        const form_data: string = form.serialize()

        this.service.ajax_update_additional_assembly( project.post_id, form_data )
    }


}

export class List_Manage_Assembly_Presenter extends Manage_Assembly_Presenter {
    list: Grid_List

    constructor( list: Grid_List ) {
        super()
        this.list = list
    }

    ready() {
        super.ready()
        this.init_events()
    }

    init_events() {
        jQuery( this.list.get_container() ).on(
            'click',
            ( e: ClickEvent ): void => {
                const target = e.target.closest( '.column-item' )

                console.log( 'list click', e.target, target )

                if ( e.target.dataset.action === 'update-project-assembly-date' ) {
                    this.init_modal_update_assembly( target )
                    return
                }
            }
        )
    }

    init_modal_update_assembly( item: HTMLElement ) {
        console.log( 'init meta modal: update-project-assembly', item )

        const post_id = Number( item.dataset.postId )

        const project = gt_results.projects.find( ( el: GT_Project ): boolean => el.post_id === post_id )
        console.log( 'project', project )

        if ( ! project ) {
            throw new Error( 'project not found' )
        }

        const dates: GT_Assembly_Date[] = gt_results.dates.filter( ( el: GT_Date ): boolean => el.project_post_id === post_id )

        this.modal.init_modal_update_assembly( project, project.assembly, dates )
    }

    /**
     * Event Handlers - Assembly
     */

    on_update_assembly_form_success( e: SubmitEvent ) {
        console.log( 'update assembly', e.currentTarget )

        // enable AJAX
        e.preventDefault()

        const form = jQuery( e.currentTarget )
        const form_data: string = form.serialize()

        const post_id = form.find( 'input[name="post-id"]' ).val() as number

        this.service.ajax_update_assembly( post_id, form_data )
    }

    on_update_assembly_ajax_success( _project_data: GT_Project, dates: GT_Date[] ): void {
        this.list.set_dates( dates )
        this.list.reload_results()
    }

    /**
     * Event Handlers - Additional Assembly
     */

    on_add_additional_assembly_form_success( e: SubmitEvent ) {
        console.log( 'add additional assembly', e )

        // enable AJAX
        e.preventDefault()

        const form = jQuery( e.currentTarget )
        const form_data: string = form.serialize()

        const post_id = form.find( 'input[name="project-post-id"]' ).val() as number
        this.service.ajax_add_additional_assembly( post_id, form_data )
    }

    on_update_additional_assembly_ajax_success( dates: GT_Date[] ) {
        this.list.set_dates( dates )
        this.list.reload_results()
    }

    on_update_additional_assembly_form_success( e: SubmitEvent ) {
        console.log( 'update additional assembly', e )

        // enable AJAX
        e.preventDefault()

        const form = jQuery( e.currentTarget )
        const form_data: string = form.serialize()

        const post_id = form.find( 'input[name="project-post-id"]' ).val() as number
        this.service.ajax_update_additional_assembly( post_id, form_data )
    }
}

export class Manage_Assembly_Service {
    ajax_update_assembly( post_id: number, form_data: string ) {
        const submit = jQuery( '#form-edit-project-assembly .submit' )
        submit.attr( 'disabled', 'disabled' )
        submit.addClass( [ 'loading', 'elastic' ] )

        const { nonce, ajax_url } = gt_ajax_object

        const data = {
            action: 'update_project_assembly',
            post_id,
            form_data,
            nonce
        }

        console.log( 'AJAX data', data )

        jQuery.ajax(
            {
                url: ajax_url,
                type: 'POST',
                dataType: 'json',
                data,
                cache: false
            }
        ).done(
            ( response ) => {
                console.log( 'AJAX response', response )

                submit.removeAttr( 'disabled' )
                submit.removeClass( [ 'loading', 'elastic' ] )

                if ( response.error ) {
                    Toast.show_ajax_response( response.toast, 'error' )
                    return
                }

                Toast.show_ajax_response( response.toast )

                bus.emit( 'update-assembly:ajax:done', response.project, response.dates )

                app.close_modals()
            }
        )
    }

    ajax_delete_assembly( post_id: number ): void {
        const { nonce, ajax_url } = gt_ajax_object

        const data = {
            action: 'delete_project_assembly',
            post_id,
            nonce
        }

        console.log( 'AJAX data', data )

        jQuery.ajax(
            {
                url: ajax_url,
                type: 'POST',
                dataType: 'json',
                data,
                cache: false
            }
        ).done(
            ( response ) => {
                console.log( 'AJAX response', response )

                if ( response.error ) {
                    Toast.show_ajax_response( response.toast, 'error' )
                    return
                }

                Toast.show_ajax_response( response.toast )

                bus.emit( 'delete-assembly:ajax:done', response.project, response.dates )

                app.close_modals()
            }
        )
    }

    ajax_add_additional_assembly( post_id: number, form_data: string ): void {
        const submit = jQuery( '#form-add-project-additional-assembly .submit' )
        submit.attr( 'disabled', 'disabled' )
        submit.addClass( [ 'loading', 'elastic' ] )

        const { ajax_url, nonce } = gt_ajax_object

        const data = {
            action: 'add_additional_assembly',
            form_data,
            post_id,
            nonce,
        }

        console.log( 'AJAX data', data )

        jQuery.ajax(
            {
                url: ajax_url,
                type: 'POST',
                dataType: 'json',
                data,
                cache: false
            }
        ).done(
            ( response ) => {
                console.log( 'AJAX response', response )

                submit.removeAttr( 'disabled' )
                submit.removeClass( [ 'loading', 'elastic' ] )

                if ( response.success === false ) {
                    Toast.show_ajax_response( response.data.toast, 'error' )

                    if ( app.is_debug_enabled() ) {
                        Toast.show_ajax_response( response.data.error, 'error' )
                    }
                    return
                }

                Toast.show_ajax_response( response.toast )

                bus.emit( 'add-additional-assembly:ajax:done', response.dates )

                app.close_modals()
            }
        )
    }

    ajax_update_additional_assembly( post_id: number, form_data: string ): void {
        const submit = jQuery( '.submit' )
        submit.attr( 'disabled', 'disabled' )
        submit.addClass( [ 'loading', 'elastic' ] )

        const { ajax_url, nonce } = gt_ajax_object

        const data = {
            action: 'update_additional_assembly',
            form_data,
            post_id,
            nonce,
        }

        console.log( 'AJAX data', data )

        jQuery.ajax(
            {
                url: ajax_url,
                type: 'POST',
                dataType: 'json',
                data,
                cache: false
            }
        ).done(
            ( response ) => {
                console.log( 'AJAX response', response )

                submit.removeAttr( 'disabled' )
                submit.removeClass( [ 'loading', 'elastic' ] )

                if ( response.success === false ) {
                    Toast.show_ajax_response( response.data.toast, 'error' )

                    if ( app.is_debug_enabled() ) {
                        Toast.show_ajax_response( response.data.error, 'error' )
                    }
                    return
                }

                Toast.show_ajax_response( response.toast )

                bus.emit( 'update-additional-assembly:ajax:done', response.dates )

                app.close_modals()
            }
        )
    }

    ajax_delete_additional_assembly( post_id: number ): void {
        const { nonce, ajax_url } = gt_ajax_object

        const data = {
            action: 'delete_additional_assembly',
            post_id,
            nonce
        }

        console.log( 'AJAX data', data )

        jQuery.ajax(
            {
                url: ajax_url,
                type: 'POST',
                dataType: 'json',
                data,
                cache: false
            }
        ).done(
            ( response ) => {
                console.log( 'AJAX response', response )

                if ( response.success === false ) {
                    Toast.show_ajax_response( response.data.toast, 'error' )

                    if ( app.is_debug_enabled() ) {
                        Toast.show_ajax_response( response.data.error, 'error' )
                    }
                    return
                }

                Toast.show_ajax_response( response.toast )

                bus.emit( 'delete-additional-assembly:ajax:done', response.dates )
            }
        )
    }
}

export class Manage_Assembly_Modal {
    init_tabs() {
        console.log( 'init assembly tabs' )
        jQuery( '[data-modal="update-project-assembly"] .menu .item' ).tab()
    }

    init_modal_update_assembly( project: GT_Project, assembly: Project_Assembly_Meta, dates: GT_Date[] ): void {
        if ( ! project || ! assembly || ! dates ) {
            return
        }

        const post_id = project.post_id
        const modal = app.get_modal( 'update-project-assembly' )
        const menu_items = jQuery( '#update-assembly-menu .item' )
        const optional = jQuery( '#update-assembly-menu .item.optional' )

        const additional_buttons = jQuery( '#form-update-project-additional-assembly button' )
        const additional_field = jQuery( '#form-update-project-additional-assembly .calendar-field' )
        const additional_calendar = jQuery( '#date-additional-assembly-update' )

        // resets
        optional.addClass( 'disabled' )
        additional_calendar.calendar( 'clear' )
        menu_items.tab( 'change tab', 'update-assembly' )
        additional_field.addClass( 'disabled' )
        additional_buttons.addClass( 'disabled' )
        jQuery( '#date-additional-assembly-add' ).calendar( 'clear' )

        // sets.
        jQuery( '.project-post-id', modal ).val( post_id )
        jQuery( '#date-assembly-week-edit' ).calendar( 'set date', assembly.date )
        jQuery( '#date-assembly-date-edit' ).calendar( 'set date', assembly.date )
        this.render_additional_assembly_fields( dates, post_id )

        jQuery( '#additional-assembly-fields .checkbox' ).checkbox()

        jQuery( '#additional-assembly-fields .checkbox input' ).on(
            'change',
            ( event: ChangeEvent ): void => {
                const input = event.currentTarget as HTMLInputElement
                const post_id: number = Number( input.value )
                const date: GT_Assembly_Date|undefined = dates.find( ( el: GT_Assembly_Date ): boolean => el.post_id === post_id && el.category.slug === 'assembly' )
                const hidden = jQuery( '#form-update-project-additional-assembly input[name="date-post-id"]' )

                if ( ! date ) {
                    return
                }

                additional_field.removeClass( 'disabled' )
                additional_calendar.calendar( 'set date', date.dates.start.date )
                additional_buttons.removeClass( 'disabled' )
                hidden.val( post_id )
            }
        )

        if ( assembly.type === 'day' ) {
            jQuery( '#project-assembly-date-day-edit' ).closest( '.ui.checkbox' ).checkbox( 'check' )
            optional.removeClass( 'disabled' )
        } else {
            jQuery( '#project-assembly-date-week-edit' ).closest( '.ui.checkbox' ).checkbox( 'check' )
        }

        modal.modal( { autofocus: false } ).modal( 'show' )
    }

    init_delete_assembly_confirmation(): void {
        console.log( 'delete project assembly?' )

        const container = jQuery( '#form-edit-project-assembly' )
        const post_id: string|number|string[]|undefined = container.find( '[name="post-id"]' ).val() as number

        const confirmation = app.get_modal( 'delete-project-assembly-confirm' )

        confirmation.modal(
            {
                onApprove: () => {
                    console.log( 'approved' )
                    bus.emit( 'delete-assembly:confirmation:approved', post_id )
                }
            }
        )

        confirmation.modal( 'show' )
    }

    init_delete_additional_assembly_confirmation(): void {
        console.log( 'delete additional assembly?' )

        const container = jQuery( '#form-update-project-additional-assembly' )
        const post_id: string|number|string[]|undefined = container.find( '[name="date-post-id"]' ).val() as number

        const confirmation = app.get_modal( 'delete-additional-assembly-confirmation' )

        confirmation.modal(
            {
                onApprove: () => {
                    console.log( 'approved' )
                    bus.emit( 'delete-additional-assembly:confirmation:approved', post_id )
                }
            }
        )

        confirmation.modal( 'show' )
    }

    render_additional_assembly_fields( dates: GT_Assembly_Date[], post_id: number ) {
        console.log( 'render additional assembly fields', dates, post_id )
        const container = document.querySelector( '#additional-assembly-fields' )

        if ( ! container ) {
            return
        }

        container.innerHTML = ''

        const additional = dates.filter( el => el.category.slug === 'assembly' && el.project_post_id === post_id )

        console.log( 'filtered', additional )

        additional.sort(
            ( a: GT_Assembly_Date, b: GT_Assembly_Date ) => Assembly_Controller.sort_assembly_dates( a.dates.start.date, b.dates.start.date )
        )

        for ( const assembly of additional ) {
            const field = document.createElement( 'div' )
            field.classList.add( 'field' )

            field.innerHTML = `
                <div class="ui radio invisible checkbox">
                    <input type="radio" class="ignore-validation" name="update-additional-assembly-date" id="update-additional-assembly-${assembly.post_id}" value="${assembly.post_id}">
                    <label class="ui primary button" for="update-additional-assembly-${assembly.post_id}">${format_date( assembly.dates.start.date )}</label>
                </div>
            `

            container.appendChild( field )
        }
    }
}
